/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UnderwriteableMinter,
  UnderwriteableMinterInterface,
} from "../UnderwriteableMinter";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IGatewayRegistry",
        name: "_registry",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "contract IGatewayRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "nonce",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "_nHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "temporaryMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class UnderwriteableMinter__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _registry: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UnderwriteableMinter> {
    return super.deploy(
      _registry,
      overrides || {}
    ) as Promise<UnderwriteableMinter>;
  }
  getDeployTransaction(
    _registry: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_registry, overrides || {});
  }
  attach(address: string): UnderwriteableMinter {
    return super.attach(address) as UnderwriteableMinter;
  }
  connect(signer: Signer): UnderwriteableMinter__factory {
    return super.connect(signer) as UnderwriteableMinter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UnderwriteableMinterInterface {
    return new utils.Interface(_abi) as UnderwriteableMinterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UnderwriteableMinter {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UnderwriteableMinter;
  }
}
